<div class="pos-relative">
  <div class="keno-grid-container">
    <particle-virtual-grid [sourceKey]="data.input.sourceKey" (valueChanged)="onGridCellValueChange($event)">
    </particle-virtual-grid>
  </div>
</div>
